import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "app",
  class: "d-flex flex-column h-100"
}
const _hoisted_2 = { class: "outer" }
const _hoisted_3 = {
  key: 0,
  class: "container results",
  style: {"padding-top":"1rem"}
}
const _hoisted_4 = { class: "header" }
const _hoisted_5 = { class: "store" }
const _hoisted_6 = { class: "headertitle small" }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "headertitle large" }
const _hoisted_9 = { class: "labels" }
const _hoisted_10 = {
  class: "p-datatable p-component p-datatable-responsive-stack p-datatable-striped",
  "data-scrollselectors": ".p-datatable-wrapper"
}
const _hoisted_11 = {
  class: "p-datatable-wrapper summary",
  style: {"overflow":"hidden"}
}
const _hoisted_12 = { class: "content md:grid-cols-2 gap-6" }
const _hoisted_13 = { class: "table" }
const _hoisted_14 = { class: "p-datatable-wrapper resultitems" }
const _hoisted_15 = { class: "flex flex-col gap-3" }
const _hoisted_16 = {
  key: 1,
  class: "container results",
  style: {"padding-top":"1rem"}
}
const _hoisted_17 = { class: "header" }
const _hoisted_18 = { class: "store" }
const _hoisted_19 = { class: "shop-logo" }
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "shop-info" }
const _hoisted_22 = ["href"]
const _hoisted_23 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_24 = ["href"]
const _hoisted_25 = { class: "headertitle small" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h1", null, "INSPECTION RESULT", -1)
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("strong", null, "Date:", -1)
const _hoisted_29 = { class: "content" }
const _hoisted_30 = { class: "headertitle large" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h1", null, "INSPECTION RESULT", -1)
const _hoisted_32 = { key: 0 }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("strong", null, "Date:", -1)
const _hoisted_34 = { class: "labels" }
const _hoisted_35 = { class: "customer" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("strong", null, "Customer:", -1)
const _hoisted_37 = { class: "vehicle" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("strong", null, "Vehicle:", -1)
const _hoisted_39 = /*#__PURE__*/_createTextVNode()
const _hoisted_40 = /*#__PURE__*/_createElementVNode("strong", null, "Plate #:", -1)
const _hoisted_41 = { class: "resources" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("strong", null, "Workorder: ", -1)
const _hoisted_43 = /*#__PURE__*/_createTextVNode()
const _hoisted_44 = /*#__PURE__*/_createElementVNode("strong", null, "Odometer: ", -1)
const _hoisted_45 = { class: "resources" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("strong", null, "Service Advisor:", -1)
const _hoisted_47 = /*#__PURE__*/_createTextVNode()
const _hoisted_48 = /*#__PURE__*/_createElementVNode("strong", null, "Technician:", -1)
const _hoisted_49 = {
  class: "p-datatable p-component p-datatable-responsive-stack p-datatable-striped",
  "data-scrollselectors": ".p-datatable-wrapper"
}
const _hoisted_50 = {
  key: 0,
  class: "p-datatable-wrapper summary"
}
const _hoisted_51 = { class: "content" }
const _hoisted_52 = { class: "chart" }
const _hoisted_53 = { class: "center value cond" }
const _hoisted_54 = { class: "table" }
const _hoisted_55 = ["href"]
const _hoisted_56 = {
  key: 1,
  class: "p-datatable-wrapper resultitems"
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Inspection Results")
], -1)
const _hoisted_58 = { class: "flex items-center gap-2" }
const _hoisted_59 = ["id", "name"]
const _hoisted_60 = { class: "container footer" }
const _hoisted_61 = { class: "headertitle small" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Questions about your inspection results?")
], -1)
const _hoisted_63 = ["href"]
const _hoisted_64 = ["href"]
const _hoisted_65 = {
  href: "#",
  target: "_blank"
}
const _hoisted_66 = { style: {"margin":"1rem 0 0 0"} }

import { useRoute, useRouter } from 'vue-router';
import { ref, onMounted, computed } from 'vue';
import Chart from 'primevue/chart';
import ResultTable from '@/components/ResultTable.vue';
import moment from 'moment';

interface WorkOrderPackageInspectionLinesItem {
  Rank: string
  WorkOrderPackageInspectionLineID: string
  Title: string
  InputType: string
  Result: string
  Comment: string
  Notes: string
  ShopNotes: string
  Type: string
  LF: string
  RF: string
  LR: string
  RR: string
  UnitText: string
  Unit: string
  MediaKeys: string[]
}

type ResultCategory = 'Required' | 'Suggested' | 'OK';

export default /*#__PURE__*/_defineComponent({
  name: 'DVIResults',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const id = route.query.id ?? '';
const data = ref({
  FirstName: '',
  LastName: '',
  WorkOrderNumber: 0,
  Make: '',
  Model: '',
  Color: '',
  Plate: '',
  Technician: '',
  ServiceAdvisor: '',
  InUsage: 0,
  ServicePackage: {
    WorkOrderPackageHeader: '',
    WorkOrderPackageInspectionLines: [] as WorkOrderPackageInspectionLinesItem[]
  },
  Company: {
    Logo: '',
    CompanyName: '',
    ContactNumber: '',
    Email: '',
    Address: ''
  },
  ScheduledTime: '',
  CTA: ''
});

const parsedItems = ref<Record<ResultCategory, WorkOrderPackageInspectionLinesItem[]>>({
    Required: [],
    Suggested: [],
    OK: []
});

const dataByResult = ref();
const UsageComputed = computed(() => new Intl.NumberFormat().format(data.value.InUsage));
const ScheduledTimeComputed = computed(() => moment(data.value.ScheduledTime).format('LL'))
const chartData = ref();
const chartOptions = ref();
const loading = ref(true);
const lineItemCount = ref(0);

const collapsedStates = ref<Record<ResultCategory, boolean>>({
    Required: false,
    Suggested: false,
    OK: true
});

onMounted(async () => {
    await getDVIResultByID();
    const packages = data.value?.ServicePackage?.WorkOrderPackageInspectionLines;
    if (!packages || packages.length === 0) { // for missing ServicePackage or 0 line items
        return router.push('/');
    }
    parseDVIResultData();
    chartData.value = setChartData();
    chartOptions.value = setChartOptions();
    loading.value = false;
});

const setChartData = () => {
    const documentStyle = getComputedStyle(document.body);

    return {
        labels: dataByResult.value.map(item => item.result),
        datasets: [
            {
                data: dataByResult.value.map(item => item.count),
                backgroundColor: ['hsl(0deg, 65%, 72%)', documentStyle.getPropertyValue('--yellow-500'), documentStyle.getPropertyValue('--green-500')],
                hoverBackgroundColor: ['hsl(0deg, 70%, 77%)', documentStyle.getPropertyValue('--yellow-400'), documentStyle.getPropertyValue('--green-400')]
            }
        ]
    };
};

const setChartOptions = () => {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');

    return {
        plugins: {
            legend: {
                labels: {
                    usePointStyle: true,
                    color: textColor
                }
            }
        }
    };
};

const parseDVIResultData = () => {
    const packages = data.value?.ServicePackage?.WorkOrderPackageInspectionLines;
    const lineItems = packages.filter((item) => item.Type === 'Line');
    lineItemCount.value = lineItems.length;

    for (const line of lineItems) {
        switch (line.Result) {
            case 'Required':
                parsedItems.value.Required.push(line)
                break;
            case 'Suggested':
                parsedItems.value.Suggested.push(line)
                break;
            case 'OK':
                parsedItems.value.OK.push(line)
                break;
            default: break;
        }
    }

    dataByResult.value = (Object.keys(parsedItems.value) as ResultCategory[]).map(key => ({
        result: key,
        count: parsedItems.value[key].length,
        percentage: (parsedItems.value[key].length / lineItems.length) * 100
    }));
}

const getDVIResultByID = async () => {
    try {
        const response = await fetch(`${process.env.VUE_APP_NODEJS_BASE_URL}dviworkorders/customerreport/v2/${id}`);
        const result = await response.json();
        data.value = result.message;
    } catch (e) {
        router.push('/')
    }
}

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_Skeleton, {
                  shape: "circle",
                  width: "15rem",
                  height: "15rem"
                }),
                _createVNode(_component_Skeleton, {
                  width: "60%",
                  height: "2rem",
                  class: "mb-2"
                }),
                _createVNode(_component_Skeleton, {
                  width: "80%",
                  height: "1rem",
                  class: "mb-1"
                }),
                _createVNode(_component_Skeleton, {
                  width: "50%",
                  height: "1rem"
                })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_Skeleton, {
                  width: "15rem",
                  height: "2rem",
                  class: "mb-2"
                }),
                _createVNode(_component_Skeleton, {
                  width: "30%",
                  height: "1rem"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_Skeleton, {
                  width: "15rem",
                  height: "2rem",
                  class: "mb-2"
                }),
                _createVNode(_component_Skeleton, {
                  width: "10rem",
                  height: "1rem",
                  class: "mt-2"
                })
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_Skeleton, {
                  width: "20rem",
                  class: "mb-2"
                }),
                _createVNode(_component_Skeleton, {
                  width: "18rem",
                  class: "mb-2"
                }),
                _createVNode(_component_Skeleton, {
                  width: "15rem",
                  class: "mb-2"
                }),
                _createVNode(_component_Skeleton, {
                  width: "17rem",
                  class: "mb-2"
                })
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("h4", null, [
                  _createVNode(_component_Skeleton, { width: "12rem" })
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_Skeleton, {
                      shape: "circle",
                      width: "200px",
                      height: "200px"
                    }),
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_Skeleton, {
                        width: "100%",
                        height: "2rem",
                        class: "mb-2"
                      }),
                      _createVNode(_component_Skeleton, {
                        width: "100%",
                        height: "2rem",
                        class: "mb-2"
                      }),
                      _createVNode(_component_Skeleton, {
                        width: "100%",
                        height: "2rem",
                        class: "mb-2"
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_Skeleton, {
                    width: "15rem",
                    height: "2rem",
                    class: "mb-2"
                  }),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_Skeleton, {
                      width: "100%",
                      height: "15rem"
                    })
                  ])
                ])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("img", {
                    src: `data:image/*;base64,${data.value.Company.Logo}`,
                    alt: "Shop Logo",
                    width: "600"
                  }, null, 8, _hoisted_20)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("h1", null, _toDisplayString(data.value.Company.CompanyName), 1),
                  _createElementVNode("p", null, _toDisplayString(data.value.Company.Address), 1),
                  _createElementVNode("p", null, [
                    _createElementVNode("a", {
                      href: `tel:${data.value.Company.ContactNumber}`
                    }, _toDisplayString(data.value.Company.ContactNumber), 9, _hoisted_22),
                    _hoisted_23,
                    _createElementVNode("a", {
                      href: `mailto:${data.value.Company.Email}`
                    }, _toDisplayString(data.value.Company.Email), 9, _hoisted_24)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                (data.value.ScheduledTime)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_27, [
                      _hoisted_28,
                      _createTextVNode(" " + _toDisplayString(_unref(ScheduledTimeComputed)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                (data.value.ScheduledTime)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_32, [
                      _hoisted_33,
                      _createTextVNode(" " + _toDisplayString(_unref(ScheduledTimeComputed)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("p", _hoisted_35, [
                  _createElementVNode("span", null, [
                    _hoisted_36,
                    _createTextVNode(" " + _toDisplayString(data.value.FirstName) + " " + _toDisplayString(data.value.LastName), 1)
                  ])
                ]),
                _createElementVNode("p", _hoisted_37, [
                  _createElementVNode("span", null, [
                    _hoisted_38,
                    _createTextVNode(" " + _toDisplayString(data.value.Color) + " " + _toDisplayString(data.value.Make) + " " + _toDisplayString(data.value.Model), 1)
                  ]),
                  _hoisted_39,
                  _createElementVNode("span", null, [
                    _hoisted_40,
                    _createTextVNode(" " + _toDisplayString(data.value.Plate), 1)
                  ])
                ]),
                _createElementVNode("p", _hoisted_41, [
                  _createElementVNode("span", null, [
                    _hoisted_42,
                    _createTextVNode(" " + _toDisplayString(data.value.WorkOrderNumber), 1)
                  ]),
                  _hoisted_43,
                  _createElementVNode("span", null, [
                    _hoisted_44,
                    _createTextVNode(" " + _toDisplayString(_unref(UsageComputed)), 1)
                  ])
                ]),
                _createElementVNode("p", _hoisted_45, [
                  _createElementVNode("span", null, [
                    _hoisted_46,
                    _createTextVNode(" " + _toDisplayString(data.value.ServiceAdvisor), 1)
                  ]),
                  _hoisted_47,
                  _createElementVNode("span", null, [
                    _hoisted_48,
                    _createTextVNode(" " + _toDisplayString(data.value.Technician), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("h4", null, [
                  _createElementVNode("strong", null, _toDisplayString(data.value?.ServicePackage?.WorkOrderPackageHeader) + " Summary", 1)
                ]),
                (dataByResult.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, [
                          _createVNode(_unref(Chart), {
                            type: "doughnut",
                            data: chartData.value,
                            options: chartOptions.value
                          }, null, 8, ["data", "options"]),
                          _createElementVNode("p", _hoisted_53, _toDisplayString(lineItemCount.value) + " points", 1)
                        ]),
                        _createElementVNode("div", _hoisted_54, [
                          _createVNode(_component_DataTable, {
                            value: dataByResult.value,
                            breakpoint: "360px",
                            class: "resultsTable"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Column, {
                                field: "result",
                                header: "Result"
                              }, {
                                body: _withCtx(({ data }) => [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(`customer-badge status-${data?.result.toLowerCase()}`)
                                  }, [
                                    _createElementVNode("a", {
                                      href: `#${data?.result}`
                                    }, _toDisplayString(data?.result), 9, _hoisted_55)
                                  ], 2)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_Column, {
                                field: "count",
                                header: "Count"
                              }),
                              _createVNode(_component_Column, {
                                field: "percentage",
                                header: "Percentage"
                              }, {
                                body: _withCtx(({ data }) => [
                                  _createTextVNode(_toDisplayString(`${data.percentage.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (data.value?.ServicePackage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                      _hoisted_57,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parsedItems.value, (value, key) => {
                        return (_openBlock(), _createBlock(_component_Panel, {
                          collapsed: collapsedStates.value[key],
                          "onUpdate:collapsed": ($event: any) => ((collapsedStates.value[key]) = $event),
                          toggleable: "",
                          key: key,
                          class: _normalizeClass(value.length === 0 ? 'empty-panel' : '')
                        }, {
                          header: _withCtx(() => [
                            _createElementVNode("div", _hoisted_58, [
                              _createVNode(_component_Badge, {
                                value: value.length > 0 ? value.length : '0'
                              }, null, 8, ["value"]),
                              _createElementVNode("a", {
                                id: key,
                                name: key
                              }, null, 8, _hoisted_59),
                              _createElementVNode("span", {
                                class: _normalizeClass('customer-badge status-' + key)
                              }, _toDisplayString(key), 3)
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(ResultTable, { items: value }, null, 8, ["items"])
                          ]),
                          _: 2
                        }, 1032, ["collapsed", "onUpdate:collapsed", "class"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])),
      _createElementVNode("div", _hoisted_60, [
        _createElementVNode("div", _hoisted_61, [
          _hoisted_62,
          _createElementVNode("a", {
            href: `tel:${data.value.Company.ContactNumber}`
          }, [
            _createVNode(_component_Button, {
              label: "Call Shop",
              link: "",
              class: "p-button-rounded btn-primary mr-2"
            })
          ], 8, _hoisted_63),
          _createElementVNode("a", {
            href: `mailto:${data.value.Company.Email}?subject=${encodeURIComponent(`Inspection questions for work order #${data.value.WorkOrderNumber}`)}.`
          }, [
            _createVNode(_component_Button, {
              label: "Email Us",
              link: "",
              class: "p-button-rounded btn-primary mr-2"
            })
          ], 8, _hoisted_64),
          _createElementVNode("a", _hoisted_65, [
            _createVNode(_component_Button, {
              label: "Visit Website",
              link: "",
              class: "p-button-rounded btn-primary"
            })
          ]),
          _createElementVNode("p", _hoisted_66, _toDisplayString(data.value.CTA), 1)
        ])
      ])
    ])
  ]))
}
}

})